<template>
  <li class="school_list_item">
    <router-link :to="'/school_index?id='+objItem.id"  target="_blank">
      <div class="school_list_item_l">
        <img :src="objItem.coverPath" alt />
      </div>
      <div class="school_list_item_r">
        <div class="t">
          <div class="t_l">
            <h3>{{objItem.name}}</h3>
            <h4>
              <span>{{objItem.total_exhibition-0+(objItem.total_pavilion-0)}}</span>个展会
            </h4>
          </div>
          <div class="t_r">
            <i class="el-icon-location-outline"></i>{{objItem.province_name}}{{objItem.city_name}}
          </div>
        </div>
        <div class="b">{{objItem.synopsis}}</div>
      </div>
    </router-link>
  </li>
</template>

<script>
export default {
  props:{
    objItem: Object
  }
};
</script>

<style lang="scss" scoped>
.school_list_item {
  /*display: flex;*/
  border-bottom: 1px solid #eee;
  width: 100%;
  a{
    display: flex;
    width: 100%;
    padding: 20px 30px 20px;
    box-sizing: border-box;
  }
  .school_list_item_l {
    width: 71px;
    height: 71px;
    /*background: #f0f0f0;*/
    img {
      width: 71px;
      height: 71px;
      object-fit: contain;
    }
  }
  .school_list_item_r {
    margin-left: 30px;
    flex: 1;
    .t {
      display: flex;
      justify-content: space-between;
      height: 36px;
      line-height: 36px;
      .t_l {
        display: flex;
        h3 {
          font-size: 16px;
          color: #333;
        }
        h4 {
          font-size: 14px;
          color: #666;
          margin-left: 20px;
          span {
            color: #ff733c;
          }
        }
      }
      .t_r {
        font-size: 12px;
        color: #999;
        i{
            width: auto;
            height: auto;
        }
      }
    }
    .b {
      font-size: 14px;
      color: #666;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
